/**
 * When the user clicks very close to the edge of a page, move in that direction.
 */

import { PageSliderControlAPI } from '../types';

export class SideClickHandler {
  public enabled = true;
  public threshold = 20; // 20px from the edge of the screen
  constructor(
    private delegate: PageSliderControlAPI,
    private element: HTMLElement
  ) {
    element.addEventListener('click', this.ClickHandler.bind(this));
  }



  private ClickHandler(e: MouseEvent) {
    if (!this.enabled) { return; }

    const elementX = e.clientX - this.element.getBoundingClientRect().left;
    if (elementX < this.threshold) {
      if (e.srcElement['className'].indexOf('disabled') > 0) {
        return;
      }
      this.delegate.AnimateToPreviousPage(0);
    } else if (elementX > this.element.offsetWidth - this.threshold) {
      this.delegate.AnimateToNextPage(0);
    }
  }
}
